<template>
  <div
    class="relative bg-no-repeat bg-center bg-cover grow flex flex-col-reverse pb-6 lg:pb-10 h-[10rem] lg:h-[15rem]"
    :style="{
      backgroundImage: `url('./images/medicalstay.webp')`,
      backgroundSize: 'cover',
      backgroundPosition: 'center',
    }"
  >
      <div class="absolute inset-0 bg-[#2C5BA1] bg-opacity-40"></div>
    <div
      class="absolute inset-0 flex flex-col items-center justify-center text-white text-3xl font-bold"
    >
      <h1>{{ $t("sejour_medical") }}</h1>
      <div class="text-xs lg:text-base font-semibold text-white mt-4">
        <p class="flex flex-row gap-2">
          <a class="hover:underline" :href="`/`">{{ $t("home") }}</a>
          <span v-if="currentLanguage === 'ar'">/</span>
          <span v-if="currentLanguage !== 'ar'">\</span>
          <a class="hover:underline" :href="`/sejour`">{{
            $t("sejour_medical")
          }}</a>
        </p>
      </div>
    </div>
  </div>
  
  <!-- Medical Categories Grid -->
  <div class="container p-3.5 sm:px-6 md:px-8 lg:px-16 xl:px-16 mx-auto my-8">
    <div class="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6">
      <div
        v-for="medical in medicals"
        :key="medical.id"
      >
        <div class="relative h-48">
          <img
            :src="medical.cover"
            :alt="medical.name"
            class="w-full h-full object-cover rounded-2xl"
          />
          <div class="absolute inset-0 bg-gradient-to-t rounded-2xl from-black/50 to-transparent"></div>
        </div>
        <div class="p-4">
        <router-link
            :to="`/sejour/${medical.slug}`">
                  <h3 class="text-lg font-semibold mb-2 hover:text-blue-600 transition-colors cursor-pointer">
            <span v-if="currentLanguage === 'fr'">{{ medical.title }}</span>
            <span v-if="currentLanguage === 'ar'">{{ medical.title_ar }}</span>
            <span v-if="currentLanguage === 'en'">{{ medical.title_en }}</span>
            <span v-if="currentLanguage === 'ru'">{{ medical.title_ru }}</span>
            <span v-if="currentLanguage === 'zh'">{{ medical.title_zh }}</span>
            <span v-if="currentLanguage === 'ja'">{{ medical.title_ja }}</span>
            <span v-if="currentLanguage === 'ko'">{{ medical.title_ko }}</span>
          </h3>
        
        </router-link>

          <p class="text-gray-600 text-sm mb-4 line-clamp-3">
            <span v-if="currentLanguage === 'fr'" v-html="medical.description"></span>
            <span v-if="currentLanguage === 'ar'" v-html="medical.description_ar"></span>
            <span v-if="currentLanguage === 'en'" v-html="medical.description_en"></span>
            <span v-if="currentLanguage === 'ru'" v-html="medical.description_ru"></span>
            <span v-if="currentLanguage === 'zh'" v-html="medical.description_zh"></span>
            <span v-if="currentLanguage === 'ja'" v-html="medical.description_ja"></span>
            <span v-if="currentLanguage === 'ko'" v-html="medical.description_ko"></span>
          </p>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import axios from "axios";

export default {
  data() {
    return {
      currentLanguage: this.$i18n.locale,
      medicals: [],
    };
  },
  methods: {
    async loadMedicals() {
      try {
        const response = await axios.get(`${process.env.VUE_APP_BACKEND_URL}medical-category`);
        this.medicals = response.data;
      } catch (error) {
        console.error("Error loading medicals: ", error);
      }
    },
  },
  async created() {
    this.$store.dispatch("setLoading", true);
    try {
      await this.loadMedicals();
    } catch (error) {
      console.log("Error:", error);
    } finally {
      this.$store.dispatch("setLoading", false);
    }
  },
};
</script>